module.exports = __webpack_public_path__ + "static/img/xxxlunbo.fd7743b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/xxxlunbo.png
// module id = NHiG
// module chunks = 1